import { Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { StepsButton } from './BtnSave';
import init from './init.json';
import { useDpiaContext } from '../dpia.context';
import { FormObserve } from './Step2';
import { useEffect } from 'react';

export default function Step4(props) {
    const { t } = useTranslation(['translation', 'dpia']);

    const { setStep4, setStepNo } = useDpiaContext();

    const onNextStep = () => {
        props.form
            .validateFields()
            .then(() => {
                setStep4(true);
            })
            .catch(() => {
                setStep4(false);
            });
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };
    useEffect(() => {
        setStepNo(4)
    }, []); 
    const onValuesChange = (info, value) => {
        const checkValue = (item) =>
            item?.topicName === '' ||
            item?.topicName === null ||
            item?.topicDescription === '' ||
            item?.topicDescription === null;

        const hasNecessary = value?.necessaryProportionality?.some(checkValue);

        if (hasNecessary) {
            setStep4(false);
        } else {
            setStep4(true);
        }
    };

    return (
        <div hidden={!props?.isActive}>
            <div className="flex">
                <div>
                    <h1 className="text-2xl font-semibold text-purple">
                        {t('step 4')}: {t('Necessity and proportionality')}
                    </h1>
                    <p className="text-sm text-gray-PHX m-0">
                        {t('DPIA step 4 description')}
                    </p>
                </div>
            </div>
            <Divider />
            <div className="text-xl font-semibold">
                {t('DPIA step 4 description list')}
            </div>
            <ul>
                <li>
                    การประมวลผลข้อมูลส่วนบุคคลดังกล่าวช่วยให้ได้ผลลัพธ์ที่ประสงค์หรือไม่
                    อย่างไร
                </li>
                <li>
                    มีช่องทางอื่นหรือไม่ที่สามารถดำเนินการได้ตามสมควรเพื่อให้ได้ผลลัพธ์ที่ประสงค์เดียวกัน
                </li>
                <li>ฐานในการประมวลผลข้อมูลตามกฎหมาย</li>
                <li>แนวทางป้องกันไม่ให้มีการประมวลผลข้อมูลที่ไม่เหมาะสม</li>
                <li>แนวทางดำเนินการเพื่อประกันคุณภาพของข้อมูล</li>
                <li>
                    แนวทางดำเนินการเพื่อประกันการจัดเก็บข้อมูลเท่าที่จำเป็น
                    (data minimization)
                    ทั้งในแง่ของประเภทข้อมูลและระยะเวลาการจัดเก็บข้อมูล
                </li>
                <li>
                    แนวทางการแจ้งข้อมูลการประมวลผลข้อมูลที่เกี่ยวข้องแก่เจ้าของข้อมูล
                </li>
                <li>แนวทางดำเนินการเพื่อรองรับการใช้สิทธิของเจ้าของข้อมูล</li>
                <li>
                    มาตรการเพื่อประกันการปฏิบัติตามขั้นตอนของผู้ประมวลผลข้อมูลส่วนบุคคล
                </li>
                <li>มาตรการคุ้มครองการส่งข้อมูลระหว่างประเทศ</li>
            </ul>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                initialValues={init.necessaryProportionality}
                layout="vertical"
                name="necessaryProportionality"
                form={props?.form}
            >
                <FormObserve
                    name="necessaryProportionality"
                    form={props?.form}
                />
            </Form>
            <Divider />
            <StepsButton previous={onPreviousStep} next={onNextStep} />
        </div>
    );
}
